import React from 'react';
import { Highlighter, MessageSquare, Pencil, Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';

const HIGHLIGHT_COLORS = [
  { name: 'Yellow', value: 'yellow', bg: 'bg-yellow-200', text: 'text-yellow-900' },
  { name: 'Green', value: 'green', bg: 'bg-green-200', text: 'text-green-900' },
  { name: 'Blue', value: 'blue', bg: 'bg-blue-200', text: 'text-blue-900' },
  { name: 'Pink', value: 'pink', bg: 'bg-pink-200', text: 'text-pink-900' },
  { name: 'Orange', value: 'orange', bg: 'bg-orange-200', text: 'text-orange-900' },
];

const DRAWING_COLORS = ['#000000', '#ef4444', '#3b82f6', '#22c55e', '#f59e0b', '#8b5cf6'];

export { HIGHLIGHT_COLORS, DRAWING_COLORS };

export function AnnotationToolbar({
  activeTool, setActiveTool,
  selectedColor, setSelectedColor,
  drawingColor, setDrawingColor,
  strokeWidth, setStrokeWidth,
  showDrawingCanvas, setShowDrawingCanvas,
  onClearDrawings,
}) {
  return (
    <Card className="p-4 mb-6">
      <div className="flex items-center justify-between flex-wrap gap-4">
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium text-stone-600 mr-2">Tool:</span>
          <Button
            variant={activeTool === 'highlight' ? 'default' : 'outline'}
            size="sm"
            onClick={() => setActiveTool('highlight')}
            data-testid="highlight-tool-btn"
          >
            <Highlighter className="h-4 w-4 mr-1" />
            Highlight
          </Button>
          <Button
            variant={activeTool === 'note' ? 'default' : 'outline'}
            size="sm"
            onClick={() => setActiveTool('note')}
            data-testid="note-tool-btn"
          >
            <MessageSquare className="h-4 w-4 mr-1" />
            Note
          </Button>
          <Button
            variant={activeTool === 'draw' ? 'default' : 'outline'}
            size="sm"
            onClick={() => {
              setActiveTool('draw');
              setShowDrawingCanvas(!showDrawingCanvas);
            }}
            data-testid="draw-tool-btn"
          >
            <Pencil className="h-4 w-4 mr-1" />
            Draw
          </Button>
        </div>

        {activeTool === 'highlight' && (
          <div className="flex items-center gap-2">
            <span className="text-sm text-stone-600">Color:</span>
            {HIGHLIGHT_COLORS.map((color) => (
              <button
                key={color.value}
                onClick={() => setSelectedColor(color.value)}
                className={`w-6 h-6 rounded-full ${color.bg} border-2 ${
                  selectedColor === color.value ? 'border-slate-700' : 'border-transparent'
                }`}
                title={color.name}
              />
            ))}
          </div>
        )}

        {activeTool === 'draw' && (
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-2">
              <span className="text-sm text-stone-600">Color:</span>
              {DRAWING_COLORS.map((color) => (
                <button
                  key={color}
                  onClick={() => setDrawingColor(color)}
                  style={{ backgroundColor: color }}
                  className={`w-6 h-6 rounded-full border-2 ${
                    drawingColor === color ? 'border-slate-700' : 'border-transparent'
                  }`}
                />
              ))}
            </div>
            <div className="flex items-center gap-2">
              <span className="text-sm text-stone-600">Size:</span>
              <input
                type="range"
                min="1"
                max="10"
                value={strokeWidth}
                onChange={(e) => setStrokeWidth(parseInt(e.target.value))}
                className="w-20"
              />
            </div>
            <Button variant="outline" size="sm" onClick={onClearDrawings}>
              <Trash2 className="h-4 w-4 mr-1" />
              Clear
            </Button>
          </div>
        )}
      </div>
    </Card>
  );
}
